<ng-container *transloco="let t">
  <app-header></app-header>
  <div class="main-content-wrapper">
    <app-sidebar></app-sidebar>
    <main
      class="main-content"
      [class.main-content-expanded]="desktopSidebarCollapsed()"
      id="mainContent"
    >
      <app-content-container class="content-shell">
        <app-breadcrumbs />
        <section class="content-body">
          <router-outlet></router-outlet>
        </section>
      </app-content-container>
    </main>
  </div>
</ng-container>
